export const awardPointsAnimation = (startElement: HTMLElement, pointsContainer: HTMLElement) => {
	const startElementRect = startElement.getBoundingClientRect()
	const container = document.body

	const starSize = 16

	const totalStars = 15
	let pointsUpdated = false

	for (let i = 0; i < totalStars; i++) {
		const duration = 800 + Math.random() * 500

		const initialX = startElementRect.left + Math.random() * (startElementRect.width - starSize)
		const initialY = startElementRect.top + Math.random() * (startElementRect.height - starSize)

		const randomPercent = 0.6 + Math.random() * 0.9
		const randomOffsetX = (Math.random() - 0.5) * 160
		const randomOffsetY = Math.random() * 120
		const randomEndOffsetX = (Math.random() - 0.5) * 0.3
		const randomEndOffsetY = (Math.random() - 0.5) * 0.3

		const star = document.createElement('img')
		star.src = '/assets/star-dark.svg'
		star.alt = 'star'
		star.className = 'w-5 h-5 pointer-events-none z-[9999] fixed'

		container.appendChild(star)

		const startTime = performance.now()

		const animate = (time: number) => {
			try {
				const pointsContainerRect = pointsContainer.getBoundingClientRect()
				const targetCenterX = pointsContainerRect.left + pointsContainerRect.width / 2
				const targetCenterY = pointsContainerRect.top + pointsContainerRect.height / 2

				const endX = targetCenterX + pointsContainerRect.width * randomEndOffsetX
				const endY = targetCenterY + pointsContainerRect.height * randomEndOffsetY
				const cpX = initialX + (endX - initialX) * randomPercent + randomOffsetX
				const cpY = initialY - 120 - randomOffsetY

				const t = Math.min(1, (time - startTime) / duration)
				const easeT = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t

				const x1 = initialX + easeT * (cpX - initialX)
				const y1 = initialY + easeT * (cpY - initialY)
				const x = x1 + easeT * (endX - x1)
				const y = y1 + easeT * (endY - y1)

				const timeElapsed = duration * t
				const timeLeft = duration * (1 - t)

				let opacity = 1
				if (timeElapsed < 200) {
					opacity = timeElapsed / 200
				} else if (timeLeft < 200) {
					opacity = timeLeft / 200
				}

				const scale = 1 - t * 0.4

				star.style.transform = `translate(${x}px, ${y}px) scale(${scale})`
				star.style.opacity = `${opacity}`

				if (
					!pointsUpdated &&
					x >= pointsContainerRect.left &&
					x <= pointsContainerRect.right &&
					y >= pointsContainerRect.top &&
					y <= pointsContainerRect.bottom
				) {
					pointsUpdated = true
				}

				if (t < 1) {
					requestAnimationFrame(animate)
				} else {
					star.remove()
				}
			} catch (error) {
				if (star.parentNode) {
					star.remove()
				}
			}
		}

		star.style.left = `0px`
		star.style.top = `0px`
		star.style.opacity = '0'

		requestAnimationFrame(() => {
			star.style.opacity = '1'
			requestAnimationFrame(animate)
		})
	}
}
